module.exports = __webpack_public_path__ + "assets/twitter.ecb25700.svg";